import React from 'react';
import * as PropTypes from 'prop-types';
import {usePages} from '../../hooks/index.mjs';
import {RenderOnlyFor} from '../../components/index.mjs';

const GuideProgress = ({ decimalPoints = 0, render, useOnlyOnSurveyPages = true }) => {
  const { progress: { total, reverse } } = usePages();

  const isProgressDefined = Number.isFinite(total || 0);
  const progressTotal = (total || 0).toFixed(decimalPoints);

  const renderGuideProgress = () => {
    const progressRender = render
      ? render({ progress: progressTotal, isReverse: reverse })
      : <div className="progressBar">{progressTotal}%</div>;

    return useOnlyOnSurveyPages
      ? <RenderOnlyFor forSurveyPage={true}>{progressRender}</RenderOnlyFor>
      : progressRender;
  };

  return isProgressDefined && renderGuideProgress();
};

GuideProgress.propTypes = {
  decimalPoints: PropTypes.number,
  render: PropTypes.func,
  useOnlyOnSurveyPages: PropTypes.bool,
};

export default GuideProgress;
